import { ReactNode } from "react";
import { StylesProvider } from "@material-ui/core/styles";
import { CobeeProvider } from "@cobee/cobee-ui";
import theme from "../../infrastructure/common/theme";
import QueryProvider from "./QueryProvider";

export interface ProvidersProps {
  children: ReactNode;
}

export default function Providers({ children }: ProvidersProps): JSX.Element {
  return (
    <StylesProvider injectFirst>
      <QueryProvider>
        <CobeeProvider theme={theme}>{children}</CobeeProvider>
      </QueryProvider>
    </StylesProvider>
  );
}
